import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import ErrorIcon from 'src/assets/error.svg';

interface Props {
  description: string;
  buttonText?: string;
  onClickButton: () => void;
}
interface ZodIssue {
  code: string;
  expected: string;
  received: string;
  path: (number | string)[];
  message: string;
}

export default function ErrorAlert({
  description,
  buttonText,
  onClickButton,
}: Props) {
  const [showDetail, setShowDetail] = useState(false);
  let zodError: ZodIssue[] | null = [];
  const isZodError = description.includes('expected');
  console.log({ description, isZodError });
  if (isZodError) {
    const message = description.substring(
      description.indexOf('['),
      description.lastIndexOf(']') + 1,
    );
    try {
      console.log({ message });
      // Clean the extra escaping
      // Now parse the cleaned string
      zodError = JSON.parse(message);
    } catch (error) {
      console.error('Failed to parse JSON:', error);
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
    >
      <img height={200} width={200} alt="Carrier" src={ErrorIcon} />

      <Typography
        sx={{
          mx: 'auto',
          width: '66%',
          textAlign: 'center',
          color: 'text.secondary',
        }}
      >
        Something went wrong! Please try again later.
      </Typography>

      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setShowDetail(!showDetail)}
        >
          {showDetail ? 'Hide Detail' : 'Show Detail'}
        </Button>
        {onClickButton && (
          <Button variant="contained" color="primary" onClick={onClickButton}>
            Retry
          </Button>
        )}
      </Stack>

      {showDetail && (
        <Card
          sx={{
            p: 3,
            borderRadius: 2,
            textAlign: 'center',
            color: 'text.primary',
          }}
        >
          <CardContent>
            {isZodError ? (
              zodError?.map((issue, index) => (
                <Box
                  key={index}
                  sx={{
                    mb: 2,
                    borderLeft: '4px solid #f44336',
                    p: 2,
                    borderRadius: 1,
                  }}
                >
                  <Typography>
                    <strong>🔹 Path:</strong>{' '}
                    <Box component="code" sx={{ p: 1, borderRadius: 1 }}>
                      {issue.path.join(' > ')}
                    </Box>
                  </Typography>
                  <Typography>
                    <strong>📌 Message:</strong>{' '}
                    <span style={{ color: '#d32f2f' }}>{issue.message}</span>
                  </Typography>
                  <Typography>
                    <strong>🛠 Expected:</strong>{' '}
                    <span style={{ color: '#1976d2' }}>{issue.expected}</span> |
                    <strong> Received:</strong>{' '}
                    <span style={{ color: '#388e3c' }}>{issue.received}</span>
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography>{description}</Typography>
            )}
          </CardContent>
        </Card>
      )}
    </Box>
  );
}
